import Contact from './Contact';
import ProjectTeamContainer from './ProjectTeamContainer';
import SalesRepresentativeContainer from './SalesRepresentativeContainer';

export default {
    path: '/kontakty',
    component: Contact,
    children: [
        {
            path: 'projektovy-tym',
            name: 'contact.projectTeam',
            component: ProjectTeamContainer,
            meta: {title: 'Projektový tým'},
        },
        {
            path: 'regionalni-obchodni-zastupci',
            name: 'contact.salesRepresentative',
            component: SalesRepresentativeContainer,
            meta: {title: 'Obchodně techničtí zástupci'},
        },
    ]
}



// WEBPACK FOOTER //
// ./src/components/contact/router.js